<template>
    <div>
        <PageHeader :title="'Tipos de Treinamento'">
            <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="page-header-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
                </svg>
            </template>
        </PageHeader>

        <ActionArea>
            <BackButton :to="{ name: 'eventos' }" />
            <BaseButton skin="primary" @click="openCreate()">
                <template v-slot:icon>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                </template>
                Adicionar
            </BaseButton>
        </ActionArea>

        <!-- Loading Skeleton -->
        <div v-if="loading" class="table-container">
            <table class="min-w-full">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Gera certificado</th>
                        <th>Modelo de certificado</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in 5" :key="`tt-skeleton-${item}`" class="table-row">
                        <td v-for="cell in 4" :key="`tt-skeleton-cell-${cell}`">
                            <div class="h-3 rounded bg-gray-200 animate-pulse"></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <Alert text="Ainda não existem tipos de treinamento cadastrados" :show="!items.length && !loading" />

        <div class="table-container" v-if="items.length && !loading">
            <table class="min-w-full">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Gera certificado</th>
                        <th>Modelo de certificado</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-row" v-for="trainingType in items" :key="trainingType.id">
                        <td>
                            <span class="text-sm leading-5 text-green-900 font-semibold">{{ trainingType.name }}</span>
                        </td>
                        <td>
                            <Tag v-if="trainingType.generates_certificate" type="success" text="sim" />
                            <Tag v-else type="warning" text="não" />
                        </td>
                        <td>
                            <span class="text-sm leading-5 text-green-700">{{ trainingType.certificate_template?.name || ' -- ' }}</span>
                        </td>
                        <td>
                            <div class="flex gap-x-2">
                                <BaseButton skin="primary-outline" @click="openEdit(trainingType)">Editar</BaseButton>
                                <BaseButton skin="danger-outline" @click="destroy(trainingType.id)">Excluir</BaseButton>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- MODAL -->
        <ModalV2 ref="modalRef" :hide="true" :title="isEditForm ? 'Editar Tipo de Treinamento' : 'Novo Tipo de Treinamento'" size="md">
            <template v-slot:body>
                <div class="grid grid-cols-1 gap-y-4">
                    <BaseInput label="Nome" maxlength="120" v-model="form.name" required="true" :isInvalid="errors.name">
                        <template v-slot:tip>
                            <span v-if="errors.name" class="text-xs text-red-500">Informe o nome do tipo de treinamento</span>
                        </template>
                    </BaseInput>
                    <div class="rounded border border-gray-200 px-4 py-3">
                        <BaseCheckbox id="generates-certificate" label="Gera certificado" v-model="form.generates_certificate" />
                    </div>
                    <BaseSelect v-if="form.generates_certificate" label="Modelo de certificado" required="true" emptyOption="-- Selecione --" :options="certificateTemplateOptions" v-model="form.certificate_template_id" :isInvalid="errors.certificate_template_id">
                        <template v-slot:tip>
                            <span v-if="errors.certificate_template_id" class="text-xs text-red-500">Selecione o modelo de certificado</span>
                        </template>
                    </BaseSelect>
                </div>
            </template>
            <template v-slot:footer>
                <BaseButton skin="primary-outline" @click="closeModal()">Fechar</BaseButton>
                <BaseButton skin="primary" :disabled="loadingSubmit" @click="submit">
                    <svg v-if="loadingSubmit" class="animate-spin ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ isEditForm ? 'Atualizar' : 'Salvar' }}
                </BaseButton>
            </template>
        </ModalV2>
    </div>
</template>

<script>

import { ref, watch } from 'vue';
import Swal from 'sweetalert';
import { TrainingTypeService, CertificateTemplateService } from '../services/Entity';
import BackButton from '@/components/BackButton';
import Tag from '@/components/Tag';
import Alert from '@/components/Alert';
import ModalV2 from '@/components/ModalV2';

export default {
    name: 'TrainingTypes',
    components: {
        BackButton,
        Tag,
        Alert,
        ModalV2
    },
    setup() {
        const items = ref([]);
        const loading = ref(false);
        const loadingSubmit = ref(false);
        const modalRef = ref();
        const isEditForm = ref(false);
        const certificateTemplateOptions = ref([]);
        const form = ref({
            name: '',
            generates_certificate: false,
            certificate_template_id: ''
        });
        const errors = ref({ name: false, certificate_template_id: false });

        watch(() => form.value.name, value => { if (value && value.trim()) errors.value.name = false; });
        watch(() => form.value.certificate_template_id, value => { if (value) errors.value.certificate_template_id = false; });
        watch(() => form.value.generates_certificate, value => { if (!value) errors.value.certificate_template_id = false; });

        async function init() {
            loading.value = true;
            await Promise.all([loadItems(), loadCertificateTemplates()]);
            loading.value = false;
        }

        async function loadItems() {
            try {
                const { data: { items: list } } = await TrainingTypeService.list(1, 9999);
                items.value = list;
            } catch (err) {
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao obter os tipos de treinamento',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        async function loadCertificateTemplates() {
            try {
                const { data: { items: list } } = await CertificateTemplateService.list(1, 9999);
                certificateTemplateOptions.value = list.map(item => ({ title: item.name, value: item.id }));
            } catch (err) {
                console.log(err);
            }
        }

        function resetErrors() {
            errors.value = { name: false, certificate_template_id: false };
        }

        function openCreate() {
            isEditForm.value = false;
            form.value = { name: '', generates_certificate: false, certificate_template_id: '' };
            resetErrors();
            modalRef.value.setModalStatus('open');
        }

        function openEdit(trainingType) {
            isEditForm.value = true;
            form.value = {
                id: trainingType.id,
                name: trainingType.name,
                generates_certificate: !!trainingType.generates_certificate,
                certificate_template_id: trainingType.certificate_template_id ?? trainingType.certificate_template?.id ?? ''
            };
            resetErrors();
            modalRef.value.setModalStatus('open');
        }

        function closeModal() {
            modalRef.value.setModalStatus('close');
        }

        function buildPayload() {
            return {
                name: form.value.name,
                generates_certificate: !!form.value.generates_certificate,
                certificate_template_id: form.value.generates_certificate ? (form.value.certificate_template_id || null) : null
            };
        }

        async function submit() {
            resetErrors();
            let valid = true;

            if (!form.value.name?.trim()) {
                errors.value.name = true;
                valid = false;
            }

            if (form.value.generates_certificate && !form.value.certificate_template_id) {
                errors.value.certificate_template_id = true;
                valid = false;
            }

            if (!valid) return;

            try {
                loadingSubmit.value = true;

                if (isEditForm.value) {
                    await TrainingTypeService.update(form.value.id, buildPayload());
                    Swal({ title: 'Atualizado!', icon: 'success' });
                } else {
                    await TrainingTypeService.create(buildPayload());
                    Swal({ title: 'Salvo!', icon: 'success' });
                }

                closeModal();
                await loadItems();
            } catch (err) {
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao salvar',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            } finally {
                loadingSubmit.value = false;
            }
        }

        async function destroy(id) {
            const confirm = await Swal({
                title: 'Tem certeza que deseja excluir esse tipo de treinamento?',
                text: 'Uma vez que excluir, não será possível recuperar',
                icon: 'warning',
                buttons: {
                    cancel: 'Cancelar',
                    confirm: {
                        text: 'Excluir',
                        className: 'swal-button--danger'
                    }
                },
                dangerMode: true
            });

            if (!confirm) return;

            try {
                loading.value = true;
                await TrainingTypeService.destroy(id);
                await loadItems();
                Swal({ title: 'Excluído', icon: 'success' });
            } catch (err) {
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao excluir',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            } finally {
                loading.value = false;
            }
        }

        init();

        return {
            items,
            loading,
            loadingSubmit,
            modalRef,
            isEditForm,
            certificateTemplateOptions,
            form,
            errors,
            openCreate,
            openEdit,
            closeModal,
            submit,
            destroy
        };
    }
}
</script>
